module.exports = __webpack_public_path__ + "img/cartoonHead3-3.2f29a9ef.png";